"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useColumnTextSortConfig = void 0;
const react_1 = require("react");
const useColumnTextSortConfig = () => {
    const getSortConfig = (0, react_1.useCallback)(({ key }) => ({
        key,
        handler: (direction) => (a, b) => {
            const valueA = a[key];
            const valueB = b[key];
            return direction === 0 /* SortDirection.Ascending */ ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA);
        },
    }), []);
    return getSortConfig;
};
exports.useColumnTextSortConfig = useColumnTextSortConfig;
